// extracted by mini-css-extract-plugin
module.exports = {"vertical":"PlusToMinus_vertical__37Y0g","horizontal":"PlusToMinus_horizontal__3cIjY","root":"PlusToMinus_root__3BowK","open":"PlusToMinus_open__2_0N-"};